import { LightMode, Stack, Text } from "@chakra-ui/react"
import { Container } from "../../-components/Container"
import { Headline } from "../../-components/Headline"
import { FAQSection } from "../../-components/FAQs/Section"

export const GeneratorFAQs = () => {
    return (
        <Container py={32}>
            <LightMode>
                <Stack spacing={10}>
                    <Headline heading="Frequently Asked Questions" size="md" align="start" mb={6} />
                    <FAQSection data={data} />
                </Stack>
            </LightMode>
        </Container>
    )
}

const data = [
    {
        title: 'What is a visual sitemap?',
        answer: (
            <Stack spacing={4}>
                <Text>
                    A visual sitemap is a visualization of your website’s pages and content, and helps you understand the hierarchy of your website in a visual way. A visual sitemap provides a clear picture of a website’s content, structure, and navigation and shows the relationship between pages.
                </Text>
                <Text>
                    Visual sitemaps can be incredibly helpful when planning a new website or making changes to an existing website.
                </Text>
            </Stack>
        ),
    },
    {
        title: 'What is an XML sitemap?',
        answer: (
            <Stack spacing={4}>
                <Text>
                    An XML sitemap is a file containing a list of the pages on your website. XML sitemaps are generally intended to be read by bots, and can help search engines like Google to navigate your website to ensure all the pages that you deem important are discovered.
                </Text>
                <Text>
                    You can also use a sitemap to provide information to search engines about specific types of content on your pages, such as video and image content.
                </Text>
            </Stack>
        ),
    },
    {
        title: 'Why use a visual sitemap generator?',
        answer: (
            <Stack spacing={4}>
                <Text>
                    The primary reason is because it saves you time!
                </Text>
                <Text>
                    Instead of spending hours manually creating a visualization of your website in a tool like Figma or Miro, a visual sitemap generator allows you to crawl your website or import your XML sitemap, and produces a <strong>ready-made visualization</strong> of your website’s structure and content.
                </Text>
            </Stack>
        ),
    },
    {
        title: 'Do all visual sitemap generators crawl your website?',
        answer: (
            <Stack spacing={4}>
                <Text>
                    No. Only a few visual sitemap generators offer crawling like Rarchy does.
                </Text>
                <Text>
                    Most can only generate visual sitemaps from an import of an existing XML sitemap or CSV file, which often results in an out-of-date visualization as these files don’t always reflect recent changes to your website.
                </Text>
                <Text>
                    By generating your visual sitemap based on a fresh crawl of your website using Rarchy, you can guarantee an up-to-date visualization of your website and ensure that no pages are missed.
                </Text>
            </Stack>
        ),
    },
    {
        title: 'What technology is used to crawl websites?',
        answer: (
            <Stack spacing={4}>
                <Text>
                    Web crawlers (sometimes referred to as a spiders or spiderbots) systematically browse websites by beginning with known URLs, and following hyperlinks on those pages to discover further pages. Using a crawling tool can help website owners understand the structure of their websites, identify broken links and discover duplicate content.
                </Text>
                <Text>
                    Rarchy’s crawler can crawl your website and then generate a visual sitemap, helping you visualize the structure of your website.
                </Text>
                <Text>
                    A few notes on how Rarchy’s crawler works:
                </Text>
                <Stack>
                    <Text>
                        - Rarchy is a polite crawler, meaning we auto-throttle based on average page latency
                    </Text>
                    <Text>
                        - Rarchy always uses the user-agent Rarchy/bot (+https://www.rarchy.com)
                    </Text>
                </Stack>
            </Stack>
        ),
    },
]